(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/models/coupon.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/models/coupon.js');

'use strict';

svs.matchen = svs.matchen || {};
svs.matchen.models = svs.matchen.models || {};
const {
  wagerPaymentFlow
} = svs.components;
const {
  standardFlow,
  executePayment
} = wagerPaymentFlow;
const {
  createWager
} = svs.components.payment.createWager;
const {
  BetProperties
} = svs.components.payment.common.constants;
const shouldUseNewPlaceBet = svs.core.detect.feature('ft-wager-matchen');
const {
  formatDate
} = svs.components.lbUtils.helpers;
svs.matchen.models.Coupon = Backbone.Model.extend({
  defaults() {
    return {
      isValid: false,
      totalCost: 0,
      maximumTotalCost: 5000,
      isValidTotalCost: true,
      betAmount: 10,
      maximumBetAmount: 500,
      minimumBetAmount: 10,
      isValidBetAmount: true,
      numberOfRows: 0,
      maximumNumberOfRows: 100,
      isValidNumberOfRows: false,
      errorMessage: '',

      eventDescription: '',

      results: new svs.matchen.collections.Results(),
      xperten: undefined
    };
  },
  options: {},
  initialize(attrs, options) {
    _.extend(options, options || {});
    this.set('draw', options.draw);
    const canNotUsePIXorXperten = this.get('draw').get('sport').type === svs.components.sport.sportTypes.SportTypes.Handball;
    this.set('canNotUsePIXorXperten', canNotUsePIXorXperten, {
      silent: true
    });
    this.set('hasHeatmapExpandDown', this.get('draw').hasHeatmapExpandDown());
    this.set('hasHeatmapExpandUp', this.get('draw').hasHeatmapExpandUp());
    this.set('eventDescription', this.get('draw').get('eventDescription'), {
      silent: true
    });
    _.bindAll(this, 'setAccountBalance', 'triggerDialogAndHandleSuccessfulPayment', 'handleSuccessfulPayment', 'handleErroneousPayment', 'createWagerNewPlaceBet', 'createAndExecuteNewPlaceBet');
    this.set('xperten', new svs.matchen.models.Xperten({
      drawNumber: this.get('draw').get('drawNumber')
    }));
    this.set('reductionsRegular', new svs.matchen.collections.Reductions());
    this.initializeCouponFromLocalStorage();
    this.initListeners();
  },
  initListeners() {
    this.listenTo(this, 'change:totalCost change:betAmount change:numberOfRows', this.validateAndSave);
    this.listenTo(this.get('xperten'), 'change', this.updateCoupon);
    this.listenTo(this.get('draw'), 'outcomeChange', this.updateCoupon);
    this.listenTo(this.get('reductionsRegular'), 'change', this.updateCoupon);
    svs.components.account_balance.get(this.setAccountBalance, this);
    svs.components.account_balance.on('change', this.setAccountBalance, this);
  },
  setAccountBalance(balance) {
    this.set('accountBalance', balance);
  },
  updateCoupon() {
    const results = this.getUpdatedResults();
    const numberOfRows = results.length;
    const totalCost = numberOfRows * this.get('betAmount');
    this.set({
      results,
      numberOfRows,
      totalCost,
      hasSelections: this.hasSelections()
    });
    this.saveCouponToLocalStorage();
  },
  getUpdatedResults() {
    const xperten = this.get('xperten');
    const reductions = this.get('reductionsRegular');
    const results = new svs.matchen.collections.Results();
    if (xperten.isActive()) {
      results.addResultsFromOutcomes({
        xpertenResults: xperten.getResults()
      });
    } else {
      results.addResultsFromOutcomes({
        homeOutcomes: this.getSelectedHomeOutcomes({
          asStrings: true
        }),
        awayOutcomes: this.getSelectedAwayOutcomes({
          asStrings: true
        })
      });
      if (reductions.isHomeReduced()) {
        results.removeHomeResults();
      }
      if (reductions.isDrawReduced()) {
        results.removeDrawResults();
      }
      if (reductions.isAwayReduced()) {
        results.removeAwayResults();
      }
    }
    return results.sort();
  },
  getNumberOfRows() {
    return this.get('results') && this.get('results').length;
  },
  validate(model, changedAttributeValue, options) {
    let errorMessage = '';
    let isValid = true;
    let isValidBetAmount = true;
    let isValidNumberOfRows = true;
    let isValidTotalCost = true;
    if (this.get('numberOfRows') == 0) {
      isValid = false;
      isValidNumberOfRows = false;
    }
    if (this.get('numberOfRows') > this.get('maximumNumberOfRows')) {
      isValid = false;
      isValidNumberOfRows = false;
      errorMessage = "Ditt spel f\xE5r inneh\xE5lla max ".concat(this.get('maximumNumberOfRows'), " rader");
    }
    if (this.get('totalCost') > this.get('maximumTotalCost')) {
      isValid = false;
      isValidTotalCost = false;
      errorMessage = "Ditt spel f\xE5r kosta max ".concat(this.get('maximumTotalCost'), " kr");
    }
    if (this.get('betAmount') > this.get('maximumBetAmount') || this.get('betAmount') < this.get('minimumBetAmount')) {
      isValid = false;
      isValidBetAmount = false;
    }
    this.set({
      isValid,
      isValidTotalCost,
      isValidBetAmount,
      isValidNumberOfRows,
      errorMessage
    }, options);
  },
  validateAndSave(model, changedAttributeValue, options) {
    this.validate(model, changedAttributeValue, options);
    if (this.get('isValid')) {
      this.saveCouponToLocalStorage();
    }
  },
  getSelectedHomeOutcomes(options) {
    return this.get('draw').getHomeOutcomes().getSelectedOutcomesAsArray(options);
  },
  getSelectedAwayOutcomes(options) {
    return this.get('draw').getAwayOutcomes().getSelectedOutcomesAsArray(options);
  },
  isValid() {
    return this.get('isValid');
  },
  hasRows() {
    return this.get('numberOfRows') > 0;
  },
  hasSelections() {
    return this.get('draw').getHomeOutcomes().isAnySelected() || this.get('draw').getAwayOutcomes().isAnySelected() || this.get('xperten').isActive();
  },
  collapseHeatMap() {
    this.get('draw').getHomeOutcomes().collapseHeatMap();
    this.get('draw').getAwayOutcomes().collapseHeatMap();
  },
  createWagerNewPlaceBet(board) {
    const drawNumber = this.get('draw').get('drawNumber');
    const productId = this.get('draw').get('productId');
    const betAmount = this.get('betAmount');
    const isReduced = this.get('reductionsRegular').isAnyReductionsSelected();
    const isXperten = this.get('xperten').isActive();
    const wager = createWager().addBet(productId, bet => {
      bet.setDrawNumber(drawNumber);
      bet.setRowPrice(betAmount);
      const boardData = board;
      if (isXperten) {
        bet.addBetProperty(BetProperties.XPERTEN);
        boardData.forEach(pixSingleRow => {
          bet.addBoard(board => {
            board.addOutcomes([pixSingleRow[0]], [pixSingleRow[1]]);
          });
        });
      } else {
        const outcomesArray = boardData.map(group => group.map(outcome => parseInt(outcome, 10)));
        bet.addBoard(board => {
          if (isReduced) {
            const eventNumber = 1;
            const reductions = this.get('reductionsRegular').getUnselectedReductionsAsArray();
            board.addReduction(eventNumber, reductions);
          }
          board.addOutcomes(outcomesArray[0], outcomesArray[1]);
        });
      }
    });
    return wager;
  },
  async createAndExecuteNewPlaceBet(wager) {
    const paymentBuilder = standardFlow.createStandardPaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      wagers: [wager]
    });
    const [, error] = await executePayment.executePayment(paymentBuilder, {
      userContext: {}
    });
    if (!error) {
      if (svs.core.detect.formfactor.mobile()) {
        this.bigStat = new svs.matchen.BigStat();
        this.bigStat.closeBigStat('#matchen-nav');
      }
      svs.matchen.router.navigate('/', true);
      this.handleSuccessfulPayment(wager);
    }
  },
  pay() {
    const obj = {};
    let wager;
    let bet;
    const isXperten = this.get('xperten').isActive();
    const isReduced = this.get('reductionsRegular').isAnyReductionsSelected();
    if (isXperten) {
      wager = this.get('xperten').get('wager');
      bet = wager.bets[0];
      obj.extradata = {
        quickpick: 2
      };
    } else {
      wager = new svs.matchen.models.Wager().get('wager');
      bet = wager.bets[0];
      bet.drawNum = Number(this.get('draw').get('drawNumber'));
      bet.scoreBoards[0].boardData = [this.getSelectedHomeOutcomes({
        asStrings: true
      }), this.getSelectedAwayOutcomes({
        asStrings: true
      })];
      if (isReduced) {
        bet.scoreBoards[0].rSysData = [this.get('reductionsRegular').getUnselectedReductionsAsArray()];
        bet.scoreBoards[0].systemType = ['RSYS'];
      }
    }
    if (shouldUseNewPlaceBet) {
      let board;
      if (isXperten) {
        board = bet.expertenBoardData.eventResults[0];
      } else {
        board = bet.scoreBoards[0].boardData;
      }

      const wagerNewPlaceBet = this.createWagerNewPlaceBet(board);
      const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
      if (isSelfService && wagerPaymentFlow.selfServiceFlow) {
        const draw = this.get('draw');
        const regCloseTime = formatDate.formatDate(draw.get('regCloseTime'), true, true);
        const wagerCount = wagerPaymentFlow.selfServiceFlow.createSelfServicePaymentFlow({
          wagers: [wagerNewPlaceBet],
          regCloseTimes: [regCloseTime]
        });
        if (wagerCount) {
          this.emptyCoupon();
        }
        return;
      }
      this.createAndExecuteNewPlaceBet(wagerNewPlaceBet);
    } else {
      const totalCost = this.get('totalCost');
      bet.betAmountSalesGroup1 = svs.utils.format.CurrencyAsJupiterString(totalCost);
      bet.rowPriceMulti = this.get('betAmount');
      obj.productId = bet.productId;
      obj.message = svs.components.sport.getPaymentConfirmMessage({
        productName: 'Matchen',
        amount: bet.betAmountSalesGroup1
      });
      const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
      const self = this;
      if (isSelfService) {
        const productFlag = bet.productId;
        const cost = totalCost;
        const draw = this.get('draw');
        const regCloseTimeStr = draw ? draw.get('regCloseTime') : null;
        const regCloseTime = new Date(regCloseTimeStr);
        const description = "'Spelstopp: ".concat(svs.components.lbUtils.helpers.formatDate.formatDate(regCloseTime, true, true));
        const wagerInfo = {
          wagers: wager,
          isLive: false,
          headers: {
            source: 'SvS:LB:ITS'
          },
          productFlag,
          cost,
          description
        };
        const wagerWrapper = svs.components.selfserviceCart.generateProductItem(wagerInfo);
        svs.components.selfserviceCart.getCartInstance().actions.addItem(wagerWrapper, err => {
          if (!err) {
            self.emptyCoupon();
          }
        });
      } else {
        svs.lbUtils.wager.pay(wager, obj, this.triggerDialogAndHandleSuccessfulPayment, this.handleErroneousPayment);
      }
    }
  },
  triggerDialogAndHandleSuccessfulPayment(data) {
    this.trigger('paymentDone', this.get('totalCost'));
    this.handleSuccessfulPayment(data);
  },
  handleSuccessfulPayment(data) {
    const draw = this.get('draw');
    const roomKeys = draw.get('roomKeys');
    const productId = draw.get('productId');
    const wagerSerial = data.wagerClientSerial;
    if (roomKeys) {
      svs.components.app_notifications.setUpAppNotifications({
        productId,
        wagerSerial,
        roomKeys
      });
    }
    this.emptyCoupon();
  },
  handleErroneousPayment(response) {
    const errCodeStr = String(response.error.code);
    const errCode = parseInt(errCodeStr.replace(/\s/g, ''), 10);
    let errMessage;
    switch (errCode) {
      case 3107:
        svs.core.userSession.logout();
        errMessage = 'Du måste logga in först.';
        break;
      case 100005:
        errMessage = 'Du måste logga in först.';
        break;
      case 8124:
        errMessage = 'Omgången är stängd för spel, var vänlig försök senare.';
        break;
      case 8105:
        errMessage = 'Omgången har stängt.';
        break;
      case 8107:
        errMessage = 'Omgången har inte öppnat för spel, var vänlig försök senare.';
        break;
      default:
    }
    if (!errMessage) {
      this.trigger('paymentError', 'Tekniskt fel, var god försök senare.');
    } else {
      this.trigger('paymentError', errMessage);
    }
  },
  emptyCoupon() {
    this.deselectOutcomes();
    this.resetReductions();
    this.resetXperten();
    this.trigger('resetOutcomes');
  },
  deselectOutcomes() {
    this.collapseHeatMap();
    this.get('draw').deselectOutcomes();
  },
  resetReductions() {
    this.get('reductionsRegular').setDefaultReductions();
  },
  resetXperten() {
    this.get('xperten').resetModel({
      silent: true
    });
  },
  onDestroy() {
    svs.components.account_balance.off('change', this.setAccountBalance);
  },
  saveCouponToLocalStorage() {
    const settings = {
      drawNumber: this.get('draw').get('drawNumber'),
      isXperten: this.get('xperten').isActive(),
      betAmount: this.get('betAmount')
    };
    if (settings.isXperten) {
      settings.systemSize = this.get('xperten').getSystemSize();
      settings.reductions = this.get('xperten').getReductions();
      settings.results = this.get('xperten').getResults();
      settings.wager = this.get('xperten').get('wager');
    } else {
      settings.reductions = this.get('reductionsRegular');
      settings.homeOutcomes = this.get('draw').getHomeOutcomes().getSelectedOutcomes();
      settings.awayOutcomes = this.get('draw').getAwayOutcomes().getSelectedOutcomes();
    }
    svs.components.Storage.browser.set(svs.matchen.COUPON, svs.matchen.STORAGE_NAME + settings.drawNumber, settings, svs.components.Storage.constants.EXPIRES_1H);
  },
  initializeCouponFromLocalStorage() {
    const drawNumber = this.get('draw').get('drawNumber');
    const storedCoupon = svs.components.Storage.browser.get(svs.matchen.COUPON, svs.matchen.STORAGE_NAME + drawNumber, svs.components.Storage.constants.EXPIRES_1H);
    if (storedCoupon && storedCoupon.drawNumber === drawNumber) {
      this.set('betAmount', storedCoupon.betAmount);
      if (storedCoupon.isXperten) {
        this.get('xperten').set({
          active: true,
          results: storedCoupon.results,
          wager: storedCoupon.wager,
          systemSize: storedCoupon.systemSize,
          trySystemSize: storedCoupon.systemSize
        });
        this.get('xperten').setReductions(storedCoupon.reductions, {
          silent: true
        });
      } else {
        this.set({
          reductionsRegular: new svs.matchen.collections.Reductions(storedCoupon.reductions)
        });
        this.get('draw').getHomeOutcomes().setSelectedOutcomes(storedCoupon.homeOutcomes);
        this.get('draw').getAwayOutcomes().setSelectedOutcomes(storedCoupon.awayOutcomes);
      }
      this.updateCoupon();
      this.validate();
    }
  },
  getDraw() {
    return this.get('draw');
  },
  getXperten() {
    return this.get('xperten');
  }
});

 })(window);